// @greenlight-spec: 10-security-compliance.md
// @greenlight-spec: 28-it-dashboard-ui.md
// Shift's published legal documents, linked from the sign-in page and the
// signed-in account menu. They are Shift-hosted and identical for every
// install — never per-org settings and never served by the control plane.

export interface LegalLink {
  readonly label: string;
  readonly href: string;
}

export const LEGAL_LINKS: readonly LegalLink[] = [
  { label: 'Privacy policy', href: 'https://shifthq.ai/legal/privacy/' },
  { label: 'Terms of service', href: 'https://shifthq.ai/legal/terms/' },
];
